// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YF9J4","toggle":"styles_toggle__-a2Xo","preview":"styles_preview__2GFEb"};